import type { ReactElement } from 'react';

export type carouselCardType = {
  title: string;
  description: string;
  stepNumber: number;
  url: string | null;
  srcImage: string;
};

function CarouselCard(props: carouselCardType): ReactElement {
  const { description, stepNumber, title, srcImage } = props;

  return (
    <div className="carousel-card">
      <div className="carousel-card__image-container">
        <img src={srcImage} alt="Imagem do carrossel" />
      </div>
      <div className="carousel-card__title-container">
        <p>Passo {stepNumber}</p>
        <p>{title}</p>
      </div>
      <div className="carousel-card__description-container">
        <p>{description}</p>
      </div>
    </div>
  );
}

export default CarouselCard;
